"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HistoricDataService = /** @class */ (function () {
    function HistoricDataService() {
    }
    HistoricDataService.prototype.getHistoricDataAfterTime = function (requset) {
        return null;
    };
    return HistoricDataService;
}());
var instance = new HistoricDataService();
exports.default = instance;
//# sourceMappingURL=historicDataService.js.map


// WEBPACK FOOTER //
// ./src/core/services/data/historicDataService.js